module.exports = __webpack_public_path__ + "img/domain.8ad0a0e2.svg";